import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-modify-task',
  templateUrl: './modify-task.component.html',
  styleUrls: ['./modify-task.component.css']
})
export class ModifyTaskComponent implements OnInit {

  i: any;
  deleteId: any;
  id: any;
  task:any = []
  tagUsersdropdownList  = [];
  tagUsersselectedItems:any = [];
  tagUsersdropdownSettings:IDropdownSettings = {
    singleSelection: false,
    idField: 'userId',
    textField: 'userName',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 3,
    allowSearchFilter: true
  };
  usersList: any= []
  assignInput = ""
  addClassType = ""
  statusNote = false;
  statusNoteText = ""
  userIdList = [];
  taskType = "All"

  taskMasters:any = []
  ticketId = ''
  TicketData: any = []
  imageSingle: any = ""
  videoSingle: any = ""
  vv: any = ""
  // taskid: any;
  ttaskid:any = ""

  pageNumber: number = 0;
  totalRecords: number = 0;
  recordsPerPage:number = 10;
  tableSize: number = 10;


  constructor(private _sanitizer: DomSanitizer,private fb: FormBuilder,private toastr: ToastrService,private generic_service: GenericService) { }

  form: any | FormGroup
  editForm: any | FormGroup
  modelSubtitle = false
  fileType:any;
  file = '';
  tasks:any = []
  images:any= [];
  videos:any= [];
  audios:any= [];
  name = ""
  description = ""
  assignedTo = ""
  searchFilter = ''
  taskId = ""
  note = ""
  taskStatus = ""

  NEW_tasksCount = 0
  ASSIGNED_tasksCount = 0
  REASSIGNED_tasksCount = 0
  WORK_IN_PROGRESS_tasksCount = 0
  PENDING_tasksCount = 0
  COMPLETED_tasksCount = 0
  DEFERRED_tasksCount = 0
  PARTIALLY_COMPLETED_tasksCount = 0
  FORCE_CLOSED_tasksCount = 0
  CLOSED_tasksCount = 0
  Total_tasksCount = 0
  updateTask:any = []
  taskPercentage = ""
  cid:any

  ngOnInit(): void {
    // this.getTaskTypeCount()
    this.cid = sessionStorage.getItem('cid')
    this.getUsers()
    this.getAllTask(this.pageNumber,this.recordsPerPage);
    this.getAllTaskNameAndDescription()
    this.form = this.fb.group({
      name: [''],
      description: [''],
      assignedTo: [''],
      tagUserIds: [''],
      taskExpStartDate: [''],
      taskExpEndDate: [''],
    });
    this.editForm = this.fb.group({
      name: [''],
      description: [''],
      assignedTo: [''],
      tagUserIds: [''],
      taskExpStartDate: [''],
      taskExpEndDate: [''],
      id: [''],
    });
  }

  onTableDataChange(event: any) {
    this.pageNumber = event;
    this.getAllTask(this.pageNumber-1,this.recordsPerPage);
  }

  onItemSelect(item: any) {
    console.log(item);
  }

  onSelectAll(items: any) {
    console.log(items);
  }

  getUsers(){
    this.generic_service.getUsers().subscribe(
      (res:any)=>{
        this.usersList = res.response;
        this.tagUsersdropdownList = res.response;
        console.log(res);
      }
    )
  }

  cancelModel(){
    document.getElementById("closeModalButton")?.click()
  }

  cancelModel1(){
    document.getElementById("closeModalButton1")?.click()
  }

  updatetask(){
    let tagUserIds = [];
    for(let i = 0; i < this.tagUsersselectedItems.length; i++) {
      tagUserIds.push(Number(this.tagUsersselectedItems[i].userId))
    }
    let status = ''
    if(this.editForm.get('assignedTo').value == ''){
      status = "NEW"
    }else{
      status = "ASSIGNED"
    }
    let body = {
      "taskId": this.taskId,
      "version": 0,
      "isActive": true,
      "description": String(this.editForm.get('description').value),
      "taskRegType": "string",
      "taskRegId": "string",
      "taskSINumber": 0,
      "taskListingNumber": 0,
      "assignedTo": String(this.editForm.get('assignedTo').value),
      "taskExpStartDate": new Date(this.editForm.get('taskExpStartDate').value).getDate(),
      "taskExpEndDate": new Date(this.editForm.get('taskExpEndDate').value).getDate(),
      "taskActStartDate": 0,
      "taskActEndDate": 0,
      "taskExpDuration": 0,
      "taskActDuration": 0,
      "status": [
        {
          "note": "string",
          "taskStatus": status,
          "updatedDate": 0,
          "images": ["string"],
          "audios": ["string"],
          "videos": ["string"]
        }
      ],
      "completedPercentage": 0,
      "notes": "string",
      "audios": ["string"],
      "videos": ["string"],
      "image": ["string"],
      "tagUserIds": tagUserIds,
      "cid":this.cid,
      "name": String(this.editForm.get('name').value)
    }

    let body1 = {
      "taskId": this.taskId,
      "version": 0,
      "id": String(this.editForm.get('id').value),
      "isActive": true,
      "description": String(this.editForm.get('description').value),
      "taskSlNo": 0,
      "name": String(this.editForm.get('name').value),
      "taskRegType": "",
      "taskRegId": "",
      "taskSINumber": 0,
      "ticketId": 0,
      "taskListingNumber": 0,
      "assignedTo": String(this.editForm.get('assignedTo').value),
      "taskExpStartDate": new Date(this.editForm.get('taskExpStartDate').value).getDate(),
      "taskExpEndDate": new Date(this.editForm.get('taskExpEndDate').value).getDate(),
      "taskActStartDate": 0,
      "taskActEndDate": 0,
      "taskExpDuration": 0,
      "taskActDuration": 0,
      "status": [
        {
          "note": "",
          "taskStatus": status,
          "updatedDate": 0,
          "images": [],
          "audios": [],
          "videos": []
        }
      ],
      "completedPercentage": 0,
      "notes": "",
      "audio": [],
      "video": [],
      "image": [],
      "tagUserIds": tagUserIds,
      "cid": Number(this.cid)
    }
    console.log(body)
    this.generic_service.updateTask(body1).subscribe(
      (response:any)=>{
        console.log(response)
        this.getAllTask(this.pageNumber,this.recordsPerPage);
        // this.getTaskTypeCount()
        this.clearForm()
        this.toastr.success("Successfully Updated");
        this.cancelModel()
      },
      (err:any)=>{
        console.log(err)
        this.toastr.error(err.error.errors[0].description);
      }
    )
  }

  getSingleTask(id:any){
    this.taskId = id
    console.log("ID is:"+ id)
    this.generic_service.getSingleTask(id).subscribe(
      (response:any)=>{
        console.log(response)
        this.ttaskid = response.response.ttaskId
        this.editForm.patchValue({
          name: response.response.name,
          description: response.response.description,
          assignedTo: response.response.assignedTo,
          tagUserIds: response.response.tagUserIds,
          taskExpStartDate: response.response.taskExpStartDate,
          taskExpEndDate: response.response.taskExpEndDate,
          id: response.response.id
        })
        console.log(this.editForm.value)
      },
      (error)=>{
        console.log(error)
      }
    )
  }

  // getTaskById(id:any){
  //   // this.skillId = id
  //   this.generic_service.getTaskById(id).subscribe(
  //     (response:any)=>{
  //       console.log(response)
  //       this.editForm.patchValue({
  //         name: response.response.name,
  //         description: response.response.description,
  //         assignedTo: response.response.assignedTo,
  //         tagUserIds: response.response.tagUserIds,
  //         taskExpStartDate: response.response.taskExpStartDate,
  //         taskExpEndDate: response.response.taskExpEndDate
  //       })
  //       console.log(this.editForm.value)
  //     },
  //     (error)=>{
  //       console.log(error)
  //     }
  //   )
  // }


  getAllTask(pageNumber:any,recordsPerPage:any){
    this.taskType = "All"
    this.generic_service.getAllTask(pageNumber,recordsPerPage).subscribe(
      (response:any)=>{
        this.tasks = response.response.taskList;
        this.totalRecords = response.response.totalRecords;
      }
    )
  }

  addImageBtn(){
    document.getElementById("add-image-btn")?.click()
  }

  addVideoBtn(){
    document.getElementById("add-video-btn")?.click()
  }

  addAudioBtn(){
    document.getElementById("add-audio-btn")?.click()
  }
  open() {
    this.modelSubtitle = true;
  }

  close() {
    this.modelSubtitle = false;
    this.name = ""
    this.description = ""
    this.assignedTo = ""
  }
  
  edit(i:any){
    this.open();
  }

  statusDropdown(){
    if(this.task[0].assignedTo == '' || this.task[0].assignedTo == null){
      this.addClass('assignedTo')
    }else{
      if(this.statusNote == true){
        this.statusNote = false;
      }else{
        this.statusNote = true;
      }
    }

  }
  taskAssignToUser(taskId:any, userId: any,taskStatus:any,name:string){
    let note = "";
    // if(taskStatus == "REASSIGNED"){
    //   note = "Task ASSIGNED to " + name;
    // }
    note = "Task ASSIGNED to " + name;
    let body = {
      "taskId": Number(taskId),
      "userId": Number(userId),
      "taskStatusDTO": {
        "note": String(note),
        "taskStatus": String(taskStatus),
        "updatedDate": 0
      }
    }
    console.log(body)
    this.generic_service.taskAssignToUser(body).subscribe(
      (response:any)=>{
        console.log(response);
        this.addClass('assignedTo')
        this.getSingleTask(taskId);
      },
      (error:any)=>{
        console.log(error)
      }
    )
  }
  // updateStatus(taskId:any,){
  //   let body = {
  //     "note": String(this.note),
  //     "taskStatus": String(this.taskStatus),
  //     "updatedDate": 0,
  //     "images": this.images,
  //     "audios": [],
  //     "videos": []
  //   }
  //   console.log(body);
  //   this.generic_service.updateStatus(body,taskId).subscribe(
  //     (response:any)=>{
  //       this.statusNote = false;
  //       this.getSingleTask(taskId);
  //       this.note = ''
  //       this.taskStatus = ""
  //       console.log(response)
  //     },
  //     (error:any)=>{
  //       console.log(error)
  //     }
  //   )
  // }

  addClass(value:any){
    console.log(value)
    if(this.addClassType == ''){
      let list = document.getElementById('assign-and-tag-data')
      if(list?.classList.contains('assign-show')){
        list.classList.remove('assign-show')
        this.addClassType = ''
      }else{
        list?.classList.add('assign-show')
        this.addClassType = value
      }
    }else{
      if(this.addClassType == value){
        let list = document.getElementById('assign-and-tag-data')
        if(list?.classList.contains('assign-show')){
          list.classList.remove('assign-show')
          this.addClassType = ''
        }else{
          list?.classList.add('assign-show')
          this.addClassType = value
        }
      }else{
        this.addClassType = value
      }
    }
  }

  getTasksByStatus(status:any){
    this.taskType = status;
    this.addClassType = '';
    console.log(status)
    // this.generic_service.getTasksByStatus(status).subscribe(
    //   (res:any)=>{
    //     console.log(res)
    //     this.tasks = res.response
    //   },
    //   (err:any)=>{
    //     console.log(err)
    //   }
    // )
  }

  // getTaskTypeCount(){
  //   this.generic_service.getAllTask().subscribe(
  //     (response:any)=>{
  //       let NEW = 0
  //       let ASSIGNED = 0
  //       let REASSIGNED = 0
  //       let WORK_IN_PROGRESS = 0
  //       let PENDING = 0
  //       let COMPLETED = 0
  //       let DEFERRED = 0
  //       let PARTIALLY_COMPLETED = 0
  //       let FORCE_CLOSED = 0
  //       let CLOSED = 0
  //       this.Total_tasksCount = response.response.length
  //       for(var i=0; i<response.response.length; i++) {
  //         if(response.response[i].latestStatus == 'NEW'){
  //           NEW++;
  //         }
  //         if(response.response[i].latestStatus == 'ASSIGNED'){
  //           ASSIGNED++;
  //         }
  //         if(response.response[i].latestStatus == 'REASSIGNED'){
  //           REASSIGNED++;
  //         }
  //         if(response.response[i].latestStatus == 'WORK_IN_PROGRESS'){
  //           WORK_IN_PROGRESS++;
  //         }
  //         if(response.response[i].latestStatus == 'PENDING'){
  //           PENDING++;
  //         }
  //         if(response.response[i].latestStatus == 'COMPLETED'){
  //           COMPLETED++;
  //         }
  //         if(response.response[i].latestStatus == 'DEFERRED'){
  //           DEFERRED++;
  //         }
  //         if(response.response[i].latestStatus == 'PARTIALLY_COMPLETED'){
  //           PARTIALLY_COMPLETED++;
  //         }
  //         if(response.response[i].latestStatus == 'FORCE_CLOSED'){
  //           FORCE_CLOSED++;
  //         }
  //         if(response.response[i].latestStatus == 'CLOSED'){
  //           CLOSED++;
  //         }
  //       }
  //       console.log(response)
  //       this.NEW_tasksCount = NEW
  //       this.ASSIGNED_tasksCount = ASSIGNED
  //       this.REASSIGNED_tasksCount = REASSIGNED
  //       this.WORK_IN_PROGRESS_tasksCount = WORK_IN_PROGRESS
  //       this.PENDING_tasksCount = PENDING
  //       this.COMPLETED_tasksCount = COMPLETED
  //       this.DEFERRED_tasksCount = DEFERRED
  //       this.PARTIALLY_COMPLETED_tasksCount = PARTIALLY_COMPLETED
  //       this.FORCE_CLOSED_tasksCount = FORCE_CLOSED
  //       this.CLOSED_tasksCount = CLOSED
  //     }
  //   )
  // }

 


  // insertConversation(){
  //   let body =  {
  //     "version": 0,
  //     "isActive": true,
  //     "description": "string",
  //     "id": 0,
  //     "conversationType": "TASK",
  //     "ticketTaskId": Number(this.taskId),
  //     "userIdList": this.userIdList,
  //     "remarks": "string"
  //   }
  //   console.log(body)
  //   this.generic_service.insertConversation(body).subscribe(
  //     (response:any)=> {
  //       console.log(response)
  //       this.toastr.success(response.message)
  //     },
  //     (err:any)=> {
  //       console.log(err)
  //       this.toastr.error(err.error.errors[0].description)
  //     }
  //   )
  // }

  // taskStatusDropdown(){
  //   console.log(this.taskStatus)

  //   if(this.taskStatus == "WORK_IN_PROGRESS"){
  //     this.note = "Started working on this"
  //   }
  //   if(this.taskStatus == "COMPLETED"){
  //     this.note = "Complteed the task"
  //   }
  //   if(this.taskStatus == "PENDING"){
  //     this.note = "Moving to Pending"
  //   }
  //   if(this.taskStatus == "DEFERRED"){
  //     this.note = "Moving to deffered"
  //   }
  //   if(this.taskStatus == "PARTIALLY_COMPLETED"){
  //     this.note = "Partially completed the task"
  //   }
  //   if(this.taskStatus == "FORCE_CLOSED"){
  //     this.note = "Closing the task due to"
  //   }
  //   if(this.taskStatus == "CLOSED"){
  //     this.note = "Task Closed"
  //   }

  // }

  // updateTaskPercentage(percentage:any,taskId:any){
  //   if(this.taskPercentage != percentage){
  //     console.log(percentage)
  //     let body = {
  //       "taskId": Number(taskId),
  //       "taskPercentage": Number(percentage)
  //     }
  //     this.generic_service.updateTaskPercentage(body).subscribe(
  //       (response:any)=>{
  //         console.log(response);
  //         this.getSingleTask(taskId)
  //       },
  //       (error:any)=>{
  //         console.log(error)
  //       }
  //     )
  //   }
  // }

  // TaskPercentage(percentage:any){
  //   this.taskPercentage = percentage
  //   console.log(this.taskPercentage)
  // }

  clearForm(){
    this.tagUsersselectedItems = []
    this.images = [];
    this.videos = [];
    this.audios = [];
    this.form.reset()
  }

  searchclear(){
    this.searchFilter = ""
    this.getAllTask(this.pageNumber,this.recordsPerPage);
  }

  taskFilterByWildSearch(searchKey:any){
    console.log(searchKey)
    console.log(searchKey.length)

    if(searchKey == ""){
      this.getAllTask(this.pageNumber,this.recordsPerPage);
    }else{
      this.generic_service.taskFilterByWildSearch(searchKey).subscribe(
        (response:any)=>{
          console.log(response)
          this.tasks = response.response;
        },
        (error:any)=>{
          console.log(error)
        }
      )
    }
  }
  getSingleTicket(id:any){
    console.log(id)
    this.TicketData = []
    this.generic_service.getSingleTicket(id).subscribe(
      (res:any)=>{
        this.TicketData = [];
        this.TicketData.push(res.response.ticket);
      }
    )
  }

  viewImage(image:string){
    this.videoSingle = ""
    this.vv = ""

    this.imageSingle = image
  }
  viewVideo(video:any){
    this.imageSingle = ""
    this.videoSingle = video
    this.vv = this._sanitizer.bypassSecurityTrustResourceUrl(this.videoSingle);
  }

  onChange(event: any) {
    this.file = event.target.files[0];
    this.onUpload()
  }
  
  onUpload() {
    console.log(this.file);
    this.generic_service.uploadImage(this.file).subscribe((event: any) => {
      console.log(event);
      this.images.push(event.response)
  
    });
  }

  getAllTaskNameAndDescription(){
    this.generic_service.getAllTaskNameAndDescription().subscribe(
      (response:any)=>{
        console.log(response)
        this.taskMasters = response.response
        console.log(this.taskMasters)
      }
    )
  }

  autoFill(taskName: any,taskDescription:any){
        this.editForm.get('name').setValue(taskName);
        this.editForm.get('description').setValue(taskDescription);
        this.cancelModel1()
      }

}
